const tiposOperadores = [
    { label: 'É igual a', value: 'igual_a' },
    { label: 'É diferente de', value: 'diferente_de' },
    { label: 'É maior que', value: 'maior_que' },
    { label: 'É maior ou igual a', value: 'maior_igual_a' },
    { label: 'É menor que', value: 'menor_que' },
    { label: 'É menor ou igual a', value: 'menor_igual_a' },
    { label: 'Contém', value: 'contem' },
    { label: 'Não contém', value: 'nao_contem' },
    { label: 'É nulo / vazio', value: 'nulo_vazio' },
    { label: 'Não é nulo / vazio', value: 'nao_nulo_vazio' },
    { label: 'Corresponde ao padrão (Regex)', value: 'corresponde_ao_padrao' },
    { label: 'Não corresponde ao padrão (Regex)', value: 'nao_corresponde_ao_padrao' },
];

export default tiposOperadores;